import React from 'react'
import { Modal, Button, Row, Col } from 'react-bootstrap'
import { Account } from '../../../../../back-end/utilities/apiDefinitions'

interface DialogProps {
	show: boolean
	handleClose: () => void
	handleConfirm?: () => void
	titleText?: string
	bodyText?: string | JSX.Element
	children?: JSX.Element
	cancelText?: string
	confirmText?: string
	// for account switch usage
	elements?: Account[]
	currentElem?: string
	handleLogIn?: (accountID: string) => void
	//show only one button
	showOnebutton?: boolean
	style?: React.CSSProperties
	centered?: boolean
}

const Dialog = (props: DialogProps) => {
	return (
		<Modal show={props.show} onHide={props.handleClose} style={props.style ? props.style : {}} centered={props.centered || false}>
			{props.titleText ? (
				<Modal.Header closeButton>
					<Modal.Title>{props.titleText}</Modal.Title>
				</Modal.Header>
			) : null}
			{props.bodyText ? <Modal.Body style={{ whiteSpace: 'pre-wrap' }}>{props.bodyText}</Modal.Body> : props.children!}
			{props.elements ? (
				<Modal.Body>
					{props.elements.map((acc: Account, index: number) => (
						<Row style={{ padding: '15px' }} key={index}>
							<Col style={{ marginTop: '7px' }}>{acc.name}</Col>
							<Col sm="5">
								<Button disabled={acc.accountID === props.currentElem!} onClick={() => props.handleLogIn!(acc.accountID!)}>
									Log-In
								</Button>
							</Col>
						</Row>
					))}
				</Modal.Body>
			) : props.showOnebutton ? (
				<Modal.Footer>
					<Button
						variant={'success'}
						onClick={() => {
							props.handleClose()
							props.handleConfirm!()
						}}
					>
						{props.confirmText || 'Confirm'}
					</Button>
				</Modal.Footer>
			) : (
				<Modal.Footer>
					<Button variant={'secondary'} onClick={props.handleClose}>
						{props.cancelText || 'Cancel'}
					</Button>
					<Button
						variant={'success'}
						onClick={() => {
							props.handleClose()
							props.handleConfirm!()
						}}
					>
						{props.confirmText || 'Confirm'}
					</Button>
				</Modal.Footer>
			)}
		</Modal>
	)
}

export { Dialog }
